<template>
  <div class="base_color">
    <div id="container">

      <div class="crossBox"><van-icon @click="close" class="cross" name="cross" /></div>
      <div class="clause">
        <div>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-align:center; line-height:150%; widows:0; orphans:0; font-size:16px">
      <span style="font-family:'黑体'; font-weight:bold; font-size:16px">上海浦东发展银行借记卡服务协议</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:30pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:15pt">
      <span style="font-family:'仿宋_GB2312'">&#xa0;</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">上海浦东发展银行借记卡（以下简称借记卡）是由</span><span
        style="font-family:'宋体'">上海浦东发展银行（以下简称</span><span style="font-family:'宋体'">乙</span><span
        style="font-family:'宋体'">方）</span><span
        style="font-family:'宋体'">面向个人客户公开发行的、符合乙方已加入的相关银行卡清算机构（以下简称“银行卡清算机构”）发卡标准的人民币借记卡。借记卡无附属卡。</span><span
        style="font-family:'宋体'">除双方另有约定外，个人客户申领乙方的各类</span><span style="font-family:'宋体'">型</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">均受本协议约束。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">申请人（以下简称</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方）与</span><span style="font-family:'宋体'">乙</span><span
        style="font-family:'宋体'">方</span><span style="font-family:'宋体'">就</span><span
        style="font-family:'宋体'">申领、</span><span style="font-family:'宋体'">使</span><span
        style="font-family:'宋体'">用借记卡</span><span style="font-family:'宋体'">事</span><span
        style="font-family:'宋体'">宜</span><span style="font-family:'宋体'">签</span><span
        style="font-family:'宋体'">订</span><span style="font-family:'宋体'">如</span><span
        style="font-family:'宋体'">下协议：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第一条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">甲方知悉、理解并自愿遵守《上海浦东发展银行借记卡章程》（以下简称“章程”）</span><span
        style="font-family:'宋体'">和本协议约定：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'; font-weight:bold">当甲方在纸质版的《上海浦东发展银行个人开户申请书》（以下称“开户申请书”）上签名后视为甲方已签署本服务协议；或甲方在电子渠道勾选并</span><span
        style="font-family:'宋体'; font-weight:bold">同意</span><span
        style="font-family:'宋体'; font-weight:bold">接受本服务协议时，视为甲方已签署本服务协议</span><span
        style="font-family:'宋体'; font-weight:bold">并生效</span><span style="font-family:'宋体'; font-weight:bold">。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方签署本服务协议后，表明甲方已知悉并同意遵守章程及本服务协议，并接受其约束。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第二条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">信息披露</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（一）</span><span
        style="font-family:'宋体'; font-weight:bold">甲方办理借记卡即视为同意授权乙方因提供借记卡服务所需获取、存储甲方的相关信息。甲方应向乙方提供真实、准确、完整、有效的资料。乙方承诺对甲方的申请资料及相关信息按照法律法规规定履行保密义务，采取有效措施保护</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">信息安全，且仅在为</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">提供本服务</span><span
        style="font-family:'宋体'; font-weight:bold">服务</span><span
        style="font-family:'宋体'; font-weight:bold">之所需的期限内存储</span><span
        style="font-family:'宋体'; font-weight:bold">甲方</span><span
        style="font-family:'宋体'; font-weight:bold">的个人信息，未经甲方同意不得向任何单位或个人披露。但甲方同意在以下情况授权乙方向第三方提供甲方信息：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">1</span><span
        style="font-family:'宋体'; font-weight:bold">．</span><span
        style="font-family:'宋体'; font-weight:bold">乙方按照国家法律法规监管规定向监管机构或国家有权机关提供甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">2</span><span
        style="font-family:'宋体'; font-weight:bold">．乙方因实施催收和追索欠款等维护自身合法权益的需要向催收服务外包单位提供服务必要的甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">3</span><span
        style="font-family:'宋体'; font-weight:bold">．根据甲方申请为甲方制作</span><span
        style="font-family:'等线'; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">邮寄借记卡实体卡的需要向银行卡制卡外包单位和承运单位提供必要的甲方相关信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">4. </span><span
        style="font-family:'宋体'; font-weight:bold">乙方因履行反洗钱监管要求</span><span
        style="font-family:'等线'; font-weight:bold">,</span><span
        style="font-family:'宋体'; font-weight:bold">对甲方信息进行核实或开展尽职调查时</span><span
        style="font-family:'等线'; font-weight:bold">,</span><span
        style="font-family:'宋体'; font-weight:bold">可以向第三方提供甲方的信息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">5.</span><span
        style="font-family:'宋体'; font-weight:bold">根据甲方申请开立他行</span><span
        style="font-family:'等线'; font-weight:bold">Ⅱ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡或</span><span
        style="font-family:'等线'; font-weight:bold">Ⅲ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡时，将本行借记卡账户作为绑定账户，经开户银行发起身份验证时，同意乙方将甲方指定借记卡相关的必要个人信息包括但不限于姓名、身份证号、手机号码、银行卡信息等与开户银行及其委托单位上送的</span><span
        style="font-family:'宋体'; font-weight:bold">个人信息比对验证，并将对比核验结果告知开户银行及其委托单位，并留存核验记录。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">6</span><span
        style="font-family:'等线'; font-weight:bold">.</span><span
        style="font-family:'宋体'; font-weight:bold">法律法规监管另有规定或双方其他约定的。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'; font-weight:bold">（二）甲方办理联名借记卡即视同愿意接受卡片联名方的服务，因联名方用于提供联名卡服务所需甲方授权乙方将持卡人的手机号码等相关信息提供给联名方。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（三）</span><span
        style="font-family:'宋体'; font-weight:bold">其他因提供服务需要而需甲方授权乙方将甲方相关信息提供给第三方的，乙方应将信息使用的目的、范围和具体情形告知甲方并由甲方自行选择是否继续办理。甲方选择办理的，即视为理解并同意上述条款内容。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第三条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">借记卡服务</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）借记卡具有有效期。</span><span
        style="font-family:'宋体'; font-weight:bold">实体借记卡有效期</span><span
        style="font-family:'宋体'; font-weight:bold">以卡片载明的有效期为准</span><span
        style="font-family:'宋体'; font-weight:bold">，有效期到期后甲方应持本人有效身份证件办理换卡手续；</span><span
        style="font-family:'宋体'">电子借记卡有效期可通过乙方渠道查询，电子借记卡有效期到期时</span><span style="font-family:'宋体'">将</span><span
        style="font-family:'宋体'">自动延长一个有效期周期，退市产品除外。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">借记卡</span><span
        style="font-family:'宋体'; font-weight:bold">有效期过期后，通过受理实体卡发生的交易受限，</span><span
        style="font-family:'宋体'">但通过电子渠道发生的交易不受限制。</span><span
        style="font-family:'宋体'">如乙方已提示甲方过期但甲方未及时办理新卡更换手续而造成卡片无法正常使用的，乙方不承担任何责任。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; font-size:10.5pt">
      <span style="font-family:'宋体'">对已过期的借记卡，甲方使用借记卡期间所发生的债权债务关系不变。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）甲方可申请实体借记卡，也可申请电子借记卡。甲方申请电子借记卡</span><span
        style="font-family:'宋体'">的，</span><span style="font-family:'宋体'">电子借记卡的备用金账户为</span><span
        style="font-family:'等线'">I</span><span style="font-family:'宋体'">类户或Ⅱ类普通账户</span><span
        style="font-family:'宋体'">且</span><span style="font-family:'宋体'">经乙方人员面对面核实身份</span><span
        style="font-family:'宋体'">后</span><span style="font-family:'宋体'">，</span><span
        style="font-family:'宋体'">方可</span><span style="font-family:'宋体'">再申请将电子借记卡换成实体借记卡。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）</span><span
        style="font-family:'宋体'">甲方可向乙方申请将借记卡实体卡选择以邮寄方式寄送甲方指定地址。实体借记卡邮寄至甲方指定的地址是乙方提供的增值服务，</span><span
        style="font-family:'宋体'; font-weight:bold">甲方自主选择该服务并支付增值服务费。</span><span
        style="font-family:'宋体'">甲方申请邮寄领卡，应确保提供的邮寄信息完整、真实、准确并确保按时收件。</span><span
        style="font-family:'宋体'; font-weight:bold">如因甲方提供的邮寄信息不真实、不完整、不准确、无法联系、无法签收等甲方原因造成邮寄服务方按照甲方在乙方处预留的信息联系甲方收件失败或未及时签收等原因导致的邮寄不达，乙方不承担责任</span><span
        style="font-family:'宋体'">；对于因乙方或乙方邮寄服务方原因造成的邮寄不达，乙方将安排免费重邮。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（四）甲方申请将借记卡邮寄至甲方指定地址的，为确保邮寄途中的卡片安全，</span><span
        style="font-family:'宋体'; font-weight:bold">甲方收到实体卡后应通过乙方指定渠道启用实体卡后方可使用。</span><span
        style="font-family:'宋体'">如实体卡在邮寄途中遗失、损坏等，甲方可向乙方申请作废该实体卡或由乙方自主作废该实体卡。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方可向乙方申请将借记卡实体卡邮寄至乙方网点，</span><span
        style="font-family:'宋体'; font-weight:bold">自实体卡到达乙方网点且乙方通知甲方领卡之日起</span><span
        style="font-family:'等线'; font-weight:bold">6</span><span
        style="font-family:'宋体'; font-weight:bold">个月内甲方未至发卡机构网点领取，发卡机构有权对借记卡实体卡进行作废处理。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（五）</span><span
        style="font-family:'宋体'; font-weight:bold">为便利甲方的小额交易用卡，乙方发行的带有“闪付”或“</span><span
        style="font-family:'等线'; font-weight:bold">QuickPass</span><span
        style="font-family:'宋体'; font-weight:bold">”标识的银联</span><span
        style="font-family:'等线'; font-weight:bold">IC</span><span
        style="font-family:'宋体'; font-weight:bold">卡支持开通小额免密免签功能，甲方可根据需要选择开通。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方开通</span><span
        style="font-family:'宋体'; font-weight:bold">小额免密免签功能后</span><span
        style="font-family:'宋体'; font-weight:bold">在境内银联指定商户进行一定金额以下的“闪付”交易时，</span><span
        style="font-family:'宋体'; font-weight:bold">只需将卡片靠近受理终端感应区即可完成支付，</span><span
        style="font-family:'宋体'; font-weight:bold">无需验证密码，也无需在打印凭证上签名。小额免密免签功能的限额以乙方对外公布的限额为准并可经乙方通过公告等方式告知甲方后调整。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方可通过乙方渠道开通、查询、调整免密限额或关闭该功能。上述规则如银联卡组织调整，则以调整后的规则为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（六）甲方遗失或卡号泄露等，应立即向乙方申请借记卡挂失，挂失成功后借记卡不可对外支付，</span><span
        style="font-family:'宋体'; font-weight:bold">但挂失前已签约本行绑定卡关联还贷款</span><span
        style="font-family:'等线'; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">信用卡的业务不受影响（另有其他约定的除外）</span><span style="font-family:'宋体'">。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">借记卡挂失分为口头挂失和书面挂失，甲方可通过乙方的电话银行、网上银行或营业网点办理口头挂失</span><span
        style="font-family:'宋体'">，</span><span style="font-family:'宋体'">或通过乙方的营业网点办理书面挂失。</span><span
        style="font-family:'宋体'; font-weight:bold">口头挂失不作为办理补卡或销卡的依据，持卡人如需办理补卡或销卡必须先办理书面挂失。</span><span
        style="font-family:'宋体'; font-weight:bold">口头挂失或书面挂失自办妥之时</span><span
        style="font-family:'宋体'; font-weight:bold">生效，</span><span
        style="font-family:'宋体'; font-weight:bold">挂失生效前的经济损失由甲方自行承担。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">甲方可向乙方申请将已挂失的借记卡解除挂失，解挂后该借记卡恢复对外支付功能。甲方也可向乙方申请对已挂失的借记卡进行补卡，为了甲方的用卡安全，补卡后新卡卡号不同于老卡卡号。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（七）自挂失生效后，发生的非甲方真实交易意愿及授权而造成的债务和损失不再由甲方承担，</span><span
        style="font-family:'宋体'; font-weight:bold">但因以下情况造成的债务和损失除</span><span
        style="font-family:'宋体'; font-weight:bold">外：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">1.</span><span
        style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方有</span><span
        style="font-family:'宋体'; font-weight:bold">欺诈</span><span
        style="font-family:'宋体'; font-weight:bold">或</span><span
        style="font-family:'宋体'; font-weight:bold">其</span><span
        style="font-family:'宋体'; font-weight:bold">他虚假</span><span
        style="font-family:'宋体'; font-weight:bold">行为的；</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'; font-weight:bold">2.</span><span
        style="font-family:'宋体'; font-weight:bold">甲方拒绝配合乙方开展必要的调查核实工作的。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">（八）因卡片损坏、卡片升级或者卡片有效期到期等原因，甲方可向乙方申请换卡。甲方申请实时换卡，换卡成功新卡可当场领取并激活，老卡当场作废，乙方不回收老卡实体卡；甲方也可申请预约换卡，申请预约换卡至新卡启用期间，原卡仍然有效，新卡启用同时原卡作废。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">申请预约换卡至新卡启用期间：如甲方撤销预约换卡，撤销成功原预约换卡记录失效；如甲方办理老卡正式挂失，则原预约换卡记录失效，如甲方仍须换卡则应撤销预约后按挂失补卡流程办理；如甲方办理了原卡销卡，则原预约换卡记录失效。特殊类型的卡片（如地方性联名卡等）暂不提供异地换卡服务。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（九）</span><span
        style="font-family:'宋体'; font-weight:bold">甲方办理借记卡的补卡或换卡后，不影响原有</span><span
        style="font-family:'宋体'; font-weight:bold">债权</span><span
        style="font-family:'宋体'; font-weight:bold">债务责任的承担，原借记卡内</span><span
        style="font-family:'宋体'; font-weight:bold">开办的各类签约业务功能是否可以自动转至新卡，以甲方签订的相关业务协议约定为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十）</span><span style="font-family:'宋体'">对账服务</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">甲方可通过乙方营业网点、客户服务电话、网上银行、手机银行、微信银行、自助终端、短信通知等渠道和方式了解其借记卡账户内的账务变动情况。</span><span
        style="font-family:'宋体'; font-weight:bold">甲方对交易账务变动情况有异议的，应于交易发生之日起</span><span
        style="font-family:'等线'; font-weight:bold">30</span><span
        style="font-family:'宋体'; font-weight:bold">天内向乙方提出查询更正申请，否则视为甲方同意并接受所有账务情况的变动内容。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十一）</span><span style="font-family:'宋体'; font-weight:bold">开立本行或他行</span><span
        style="font-family:'等线'; font-weight:bold">Ⅱ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡或</span><span
        style="font-family:'等线'; font-weight:bold">Ⅲ</span><span
        style="font-family:'宋体'; font-weight:bold">类户电子借记卡时，</span><span
        style="font-family:'宋体'; font-weight:bold">所</span><span
        style="font-family:'宋体'; font-weight:bold">绑定</span><span
        style="font-family:'宋体'; font-weight:bold">的银行卡由于挂失、止付、有效期到期等原因不能正常使用时，客户应当到开户机构指定的渠道办理变更，否则由此产生的一切后果由客户承担。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第</span><span style="font-family:'宋体'">四条</span><span style="font-family:'宋体'">
      </span><span style="font-family:'宋体'">借记卡交易</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方</span><span style="font-family:'宋体'">收到实体</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">之</span><span
        style="font-family:'宋体'">后，须立即</span><span style="font-family:'宋体'">在</span><span
        style="font-family:'宋体'">卡片</span><span style="font-family:'宋体'">背面签</span><span
        style="font-family:'宋体'">名条上</span><span style="font-family:'宋体'">签署本人的姓</span><span
        style="font-family:'宋体'">名。</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方的</span><span style="font-family:'宋体'">签</span><span
        style="font-family:'宋体'">名应与其</span><span style="font-family:'宋体'">提供给</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方的申请证件上所</span><span
        style="font-family:'宋体'">载</span><span style="font-family:'宋体'">姓名一</span><span
        style="font-family:'宋体'">致，签名可选任意字体</span><span style="font-family:'宋体'">。甲方</span><span
        style="font-family:'宋体'">在用卡时应使用该签名。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）为</span><span style="font-family:'宋体'">获</span><span
        style="font-family:'宋体'">得</span><span style="font-family:'宋体'">货</span><span
        style="font-family:'宋体'">品</span><span style="font-family:'宋体'">或服</span><span
        style="font-family:'宋体'">务，甲方</span><span style="font-family:'宋体'">每</span><span
        style="font-family:'宋体'">一</span><span style="font-family:'宋体'">项</span><span
        style="font-family:'宋体'">通过</span><span style="font-family:'宋体'">邮</span><span
        style="font-family:'宋体'">件、</span><span style="font-family:'宋体'">电话</span><span
        style="font-family:'宋体'">、</span><span style="font-family:'宋体'">传</span><span
        style="font-family:'宋体'">真、</span><span style="font-family:'宋体'">互</span><span
        style="font-family:'宋体'">联</span><span style="font-family:'宋体'">网或</span><span
        style="font-family:'宋体'">其</span><span style="font-family:'宋体'">他</span><span
        style="font-family:'宋体'">任何</span><span style="font-family:'宋体'">方</span><span
        style="font-family:'宋体'">式并使用</span><span style="font-family:'宋体'">借记卡向商家进行的支</span><span
        style="font-family:'宋体'">付</span><span style="font-family:'宋体'">，均</span><span
        style="font-family:'宋体'">构</span><span style="font-family:'宋体'">成一</span><span
        style="font-family:'宋体'">项</span><span style="font-family:'宋体'">有</span><span
        style="font-family:'宋体'">效</span><span style="font-family:'宋体'">的借记卡</span><span
        style="font-family:'宋体'">交易</span><span style="font-family:'宋体'">，</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方将</span><span
        style="font-family:'宋体'">在</span><span style="font-family:'宋体'">甲</span><span
        style="font-family:'宋体'">方的借记卡中</span><span style="font-family:'宋体'">就</span><span
        style="font-family:'宋体'">该</span><span style="font-family:'宋体'">等</span><span
        style="font-family:'宋体'">交易</span><span style="font-family:'宋体'">进行借</span><span
        style="font-family:'宋体'">记</span><span style="font-family:'宋体'">。</span><span
        style="font-family:'宋体'">甲方不得以与商户或其它第三方存在纠纷等情形为由，拒绝支付其以借记卡完成支付所欠的款项。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）</span><span
        style="font-family:'宋体'; font-weight:bold">因不可抗力或非因乙方过错引起的系统、供电、通讯、网络故障等各项原因导致甲方用卡失败而造成损失的，乙方有义务协助甲方解决问题或提供必要的帮助，但不承担经济或法律责任。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（四）</span><span style="font-family:'宋体'">甲方在使用</span><span
        style="font-family:'宋体'">借记卡</span><span style="font-family:'宋体'">进行联机</span><span
        style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">脱机消费、存取现金及转账等交易时，须遵守法律法规监管规定、乙方、银行卡清算机构、收单机构及有关受理机构的相关规定。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（五）</span><span style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方使用借记卡开展交易取现、转账、消费等各类交易时，乙方有权根据</span><span
        style="font-family:'宋体'; font-weight:bold">国家法律法规监管规定以及乙方风险控制策略设置不同交易类型的交易限额，包括但不限于</span><span
        style="font-family:'宋体'; font-weight:bold">交易渠道</span><span
        style="font-family:'宋体'; font-weight:bold">限制</span><span
        style="font-family:'宋体'; font-weight:bold">、</span><span
        style="font-family:'宋体'; font-weight:bold">金额限制、笔数限制</span><span
        style="font-family:'宋体'; font-weight:bold">等</span><span
        style="font-family:'宋体'; font-weight:bold">，并有权根据国家法律法规监管规定及乙方业务变化等因素对相关限额进行调整。</span><span
        style="font-family:'宋体'">甲方在香港特别行政区、澳门特别行政区、台湾地区和境外</span><span style="font-family:'等线'">ATM</span><span
        style="font-family:'宋体'">提取现金的，除应遵守国家法律法规监管规定外，还应遵守所在地区或国家的法律、法规和受理机构相关规定。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（六）</span><span
        style="font-family:'宋体'; font-weight:bold">转账交易涉及有权机关依法发起冻结或强制扣划的，甲方知悉并授权乙方撤销在途的</span><span
        style="font-family:'等线'; font-weight:bold">ATM</span><span
        style="font-family:'宋体'; font-weight:bold">跨行转账交易。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">如任何非甲方应得款项错误存入甲方账户，经乙方查实的，甲方授权乙方从甲方账户中扣转该笔款项。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（七）甲方使用</span><span style="font-family:'等线'">ATM</span><span
        style="font-family:'宋体'">等自助设备时，如发生吞卡，应及时与自助设备所属机构取得联系，并按照其指定要求办理领卡手续。过期未领的，乙方将按照有关规定对被吞卡片进行销毁处理，甲方如需继续使用，须到乙方网点办理补卡手续；甲方在其他银行</span><span
        style="font-family:'等线'">ATM</span><span style="font-family:'宋体'">等自助设备发生吞卡的，应及时按照他行相关规定办理手续。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（八）</span><span
        style="font-family:'宋体'; font-weight:bold">根据银联卡业务规则对于银联渠道下的预授权交易的规定，</span><span
        style="font-family:'宋体'; font-weight:bold">甲</span><span
        style="font-family:'宋体'; font-weight:bold">方进行</span><span
        style="font-family:'宋体'; font-weight:bold">预授</span><span
        style="font-family:'宋体'; font-weight:bold">权</span><span
        style="font-family:'宋体'; font-weight:bold">交易</span><span
        style="font-family:'宋体'; font-weight:bold">时，</span><span
        style="font-family:'宋体'; font-weight:bold">乙</span><span
        style="font-family:'宋体'; font-weight:bold">方将</span><span
        style="font-family:'宋体'; font-weight:bold">按照交易</span><span
        style="font-family:'宋体'; font-weight:bold">金额的</span><span
        style="font-family:'等线'; font-weight:bold">115</span><span
        style="font-family:'等线'; font-weight:bold">%</span><span
        style="font-family:'宋体'; font-weight:bold">对甲方借记卡的可用余额（备用金账户余额</span><span
        style="font-family:'等线'; font-weight:bold">+</span><span
        style="font-family:'宋体'; font-weight:bold">约定类账户余额</span><span
        style="font-family:'等线'; font-weight:bold">-</span><span
        style="font-family:'宋体'; font-weight:bold">已冻结或锁定金额）进行</span><span
        style="font-family:'宋体'; font-weight:bold">资</span><span
        style="font-family:'宋体'; font-weight:bold">金</span><span
        style="font-family:'宋体'; font-weight:bold">锁</span><span
        style="font-family:'宋体'; font-weight:bold">定，</span><span
        style="font-family:'宋体'; font-weight:bold">锁</span><span
        style="font-family:'宋体'; font-weight:bold">定后的</span><span
        style="font-family:'宋体'; font-weight:bold">资</span><span
        style="font-family:'宋体'; font-weight:bold">金将</span><span
        style="font-family:'宋体'; font-weight:bold">不</span><span
        style="font-family:'宋体'; font-weight:bold">能</span><span
        style="font-family:'宋体'; font-weight:bold">被甲</span><span
        style="font-family:'宋体'; font-weight:bold">方用作</span><span
        style="font-family:'宋体'; font-weight:bold">包</span><span
        style="font-family:'宋体'; font-weight:bold">括</span><span
        style="font-family:'宋体'; font-weight:bold">取现在内的任</span><span
        style="font-family:'宋体'; font-weight:bold">何</span><span
        style="font-family:'宋体'; font-weight:bold">用</span><span
        style="font-family:'宋体'; font-weight:bold">途</span><span
        style="font-family:'宋体'; font-weight:bold">的支</span><span
        style="font-family:'宋体'; font-weight:bold">付</span><span
        style="font-family:'宋体'; font-weight:bold">。</span><span
        style="font-family:'宋体'; font-weight:bold">上述规则如银联卡组织调整，则以调整后的规则为准。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（九）</span><span
        style="font-family:'宋体'">乙方系统对借记卡密码采用密码录入错误限次管理。交易密码连续发生输入错误三次的，卡片将被锁定，甲方如需继续使用，须由本人持该卡并凭有效身份证件通过乙方渠道办理解锁手续。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（十）根据法律法规监管规定和基于保护持卡人资金安全目的，发卡机构有权拒绝承兑涉嫌赌、</span><span
        style="font-family:'宋体'">诈骗、非法集资、</span><span style="font-family:'宋体'">洗钱</span><span
        style="font-family:'宋体'">、金融制裁</span><span
        style="font-family:'宋体'">等违反国家法律法规监管规定的互联网交易或暂停借记卡使用及相关服务。因可能涉及非法交易所导致的损失及责任由持卡人自行承担。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第五条</span><span style="font-family:'宋体'"> </span><span
        style="font-family:'宋体'">电子现金账户</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）实体借记卡为芯片卡或磁条芯片复合卡的，其所载芯片符合人民银行金融</span><span
        style="font-family:'等线'">IC</span><span style="font-family:'宋体'">卡相关标准，可以加载非金融应用</span><span
        style="font-family:'宋体'">。甲方对借记卡进行</span><span style="font-family:'宋体'">圈存</span><span
        style="font-family:'宋体'">交易时</span><span style="font-family:'宋体'">联动开立</span><span
        style="font-family:'宋体'">电子现金账户。</span><span
        style="font-family:'宋体'; font-weight:bold">电子现金账户资金不计息、不挂失，不提供对账单服务，余额上限遵从法律法规监管规定。电子现金账户可进行圈存、脱机消费和查询，不提供支取现金和转账等其他支付结算功能，电子现金账户消费时不需进行密码验证。</span><span
        style="font-family:'宋体'; font-weight:bold">开通电子现金账户时同步开通电子现金补登账户。</span><span
        style="font-family:'宋体'; font-weight:bold">电子现金补登账户为借记卡用于</span><span
        style="font-family:'宋体'; font-weight:bold">脱机消费退货资金核算和补换卡电子现金余额资金的账户，该账户内存款不计息。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（二）甲方借记卡电子现金在换卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">补卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">销卡时退还约定</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">办理换卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">补卡</span><span style="font-family:'等线'">/</span><span
        style="font-family:'宋体'">销卡业务之前或之后，甲方可持老卡实体卡至乙方网点申请退还电子现金余额，并指定电子现金的退还方式。包括如下三种情形：</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">1.</span><span style="font-family:'宋体'">老卡可读，通过圈提方式将电子现金余额退还甲方，并对老卡作销毁处理；</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">2.</span><span style="font-family:'宋体'">老卡不可读，将于成功受理甲方退还电子现金余额申请之日起</span><span
        style="font-family:'等线'">30</span><span style="font-family:'宋体'">天后，按照甲方系统记录的电子现金账户余额退还甲方。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'等线'">3.</span><span style="font-family:'宋体'">甲方无法提供老卡，将于该实体借记卡有效期到期日</span><span
        style="font-family:'等线'">30</span><span style="font-family:'宋体'">天后，按照甲方系统记录的电子现金账户余额退还甲方。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">退还资金方式有转账和现金两种，甲方可以在销卡时约定退还资金转入的乙方借记卡卡号，或者凭本人有效身份证件到乙方营业网点领取现金；若转账失败，则甲方须按照现金领取的规则领取。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">第六条</span><span style="font-family:'宋体'; font-weight:bold">
      </span><span style="font-family:'宋体'; font-weight:bold">专用借记卡</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（一）甲方</span><span
        style="font-family:'宋体'; font-weight:bold">通过与乙方合作的第三方开立借记卡的，仅限在合作方渠道消费的借记卡为专用借记卡，该专用借记卡仅限</span><span
        style="font-family:'宋体'; font-weight:bold">II</span><span
        style="font-family:'宋体'; font-weight:bold">类户借记卡或</span><span
        style="font-family:'宋体'; font-weight:bold">III</span><span
        style="font-family:'宋体'; font-weight:bold">类户借记卡。专用借记卡的备用金账户暂不支持升级为</span><span
        style="font-family:'宋体'; font-weight:bold">I</span><span
        style="font-family:'宋体'; font-weight:bold">类户、不支持配发实体卡、不支持换卡和补卡，可在乙方柜面办理密码设置、重置、默认不设置交易密码，除此之外的功能与通用借记卡一致。除专用借记卡外的借记卡均为通用借记卡，通用借记卡具备监管规定许可范围内所有功能。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'; font-weight:bold">（二）专用借记卡在合作方渠道使用时，以短信动态密码或其他经符合合作方渠道要求的验证信</span><span
        style="font-family:'宋体'; font-weight:bold">息</span><span
        style="font-family:'宋体'; font-weight:bold">手段作为交易验证规则。凡使用密码</span><span
        style="font-family:Calibri; font-weight:bold">/</span><span
        style="font-family:'宋体'; font-weight:bold">短信动态验证码或符合约定的身份验证方式验证通过的借记卡交易，均视为客户本人所为。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">第七条</span><span style="font-family:'宋体'">其他</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（一）</span><span
        style="font-family:'宋体'">甲方违反有关法律法规监管规定或相关协议约定并给乙方造成损失的，乙方依法采取法律措施维护合法权益并依法追究甲方及有关当事人的法律责任。</span></p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span
        style="font-family:'宋体'">（二）乙方有权根据国家法律法规监管规定以及经营需要修改本协议，修改后的协议在乙方的营业网点、网站等渠道进行公告。公告期满后修改后的协议即生效，乙方无须另行通知甲方。在公告期内，甲方可选择是否继续使用借记卡及相关服务。甲方因对协议的修改有异议而决定不继续使用借记卡及相关服务的，可在公告期满前通过乙方渠道办理销卡。公告期满甲方未销卡的，即视为同意接受公告的各项内容。</span>
    </p>
    <p
      style="margin-top:0pt; margin-bottom:0pt; text-indent:21pt; text-align:justify; line-height:150%; widows:0; orphans:0; font-size:10.5pt">
      <span style="font-family:'宋体'">（三）本协议</span><span style="font-family:'宋体'">适</span><span
        style="font-family:'宋体'">用中</span><span style="font-family:'宋体'">华</span><span
        style="font-family:'宋体'">人民</span><span style="font-family:'宋体'">共</span><span
        style="font-family:'宋体'">和国法律（为本协议目的，</span><span style="font-family:'宋体'">在</span><span
        style="font-family:'宋体'">此</span><span style="font-family:'宋体'">不包</span><span
        style="font-family:'宋体'">括香港特别行政区</span><span style="font-family:'宋体'">、</span><span
        style="font-family:'宋体'">澳</span><span style="font-family:'宋体'">门特</span><span
        style="font-family:'宋体'">别</span><span style="font-family:'宋体'">行</span><span
        style="font-family:'宋体'">政区</span><span style="font-family:'宋体'">以</span><span
        style="font-family:'宋体'">及</span><span style="font-family:'宋体'">台湾</span><span
        style="font-family:'宋体'">地</span><span style="font-family:'宋体'">区的法律</span><span
        style="font-family:'宋体'">）</span><span style="font-family:'宋体'">。</span><span
        style="font-family:'宋体'">双</span><span style="font-family:'宋体'">方</span><span
        style="font-family:'宋体'">一致</span><span style="font-family:'宋体'">同意</span><span
        style="font-family:'宋体'">接</span><span style="font-family:'宋体'">受由</span><span
        style="font-family:'宋体'">乙</span><span style="font-family:'宋体'">方所</span><span
        style="font-family:'宋体'">在</span><span style="font-family:'宋体'">地有管辖权的法</span><span
        style="font-family:'宋体'">院</span><span style="font-family:'宋体'">进行</span><span
        style="font-family:'宋体'">排</span><span style="font-family:'宋体'">他</span><span
        style="font-family:'宋体'">性的司法管辖，本协议当事人另有约定的除外。本协议</span><span style="font-family:'宋体'">未</span><span
        style="font-family:'宋体'">尽</span><span style="font-family:'宋体'">事</span><span
        style="font-family:'宋体'">宜</span><span style="font-family:'宋体'">依据国家法律法规监管规定及《上海浦东发展银行借记卡章程》执行。</span></p>
  </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'pufaAccountAgreement',
  data() {
    return {};
  },
  props: {
    hidePopup: {
      type: Function,
      default: null,
    },
  },
  methods: {
    close() {
      this.hidePopup();
    },
  },
};
</script>
<style scoped>
.base_color{
  width: 100%;
  height: 100%;
}
.crossBox{
  text-align: right;
}
.cross{
  font-size: 20px;
}
#container {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
}
.clause{
  flex: 1;
  overflow: auto;
  background: #fff;
  background-size: contain;
}
* {
  /* width: 90%; */
  box-sizing: border-box;
  margin: 0;
  padding: 0;
  font-size: 12px;
}
body {
  font-family: '微软雅黑';
}
.distance {
  text-align: left;

  /* margin-left: 10px; */
}
.distance_50 {
  letter-spacing: 0;
  text-align: left;
  text-indent: 24px;
}
.distance_80 {
  text-align: left;

  /* margin-left: 10px; */
}
p {
  margin-bottom: 8px;
}
#close {
  position: fixed;
  top: 0;
  left: 0;
  box-sizing: border-box;
  width: 100%;
  height: 30px;
  padding-right: 10px;
  color: white;
  font-size: 20px;
  line-height: 30px;
  text-align: right;
  background: #3d4145;
}
.table{
  margin: 20px 10px;
}
</style>
